import React from 'react'
import { Tabs, TabsProps } from '@material-ui/core'
import { createStyles, Theme, withStyles } from '@material-ui/core/styles'

interface YumLeaderboardTabsProps extends Omit<TabsProps, 'onChange'> {
  classes: any
  children: React.ReactNode
  onChange: (event: React.ChangeEvent<{}>, value: any) => void
}

const YumLeaderboardTabs = withStyles((theme: Theme) =>
  createStyles({
    root: {
      minHeight: '40px',
      borderRadius: '0px',
      //marginBottom: '16px',
      //backgroundColor: '#E3E3E8',
      /*[theme.breakpoints.up('md')]: {
        maxWidth: '400px',
        marginLeft: 'auto',
        marginRight: 'auto',
      },*/
    },
    tabIndicator: {
      borderRadius: '2px',
    },
  }),
)(({ children, classes, ...props }: YumLeaderboardTabsProps) => {
  return (
    <Tabs
      variant="fullWidth"
      scrollButtons="off"
      textColor="primary"
      indicatorColor="primary"
      classes={{
        root: classes.root,
        //flexContainer: classes.flexContainer,
      }}
      TabIndicatorProps={{
        className: classes.tabIndicator,
      }}
      {...props}
    >
      {children}
    </Tabs>
  )
})

export default YumLeaderboardTabs
